import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  className?: string;
  isRequired?: boolean;
  label: string | ReactNode;
  labelAdditionalInfo?: string;
};
export const Legend = ({ className, isRequired, label, labelAdditionalInfo }: Props) => (
  <legend className={classnames('inline-block text-14 font-bold text-black', className)}>
    {label}
    {isRequired && '*'}
    {labelAdditionalInfo && (
      <span className="ms-10 text-12 font-normal text-grey">{labelAdditionalInfo}</span>
    )}
  </legend>
);
